<fm-context-menu-panel>
  <fm-context-menu-item *ngIf="userPermissions.findNearest"
    [hasSeparator]="true"
    id="lnk-geofence-find-nearest"
    a7s-id="live-map-geofence-context-menu-find-nearest"
    (click)="onFindNearestClicked()">
    <a i18n="@@S_FIND_NEAREST">Find nearest</a>
  </fm-context-menu-item>
  <fm-context-menu-item id="lnk-geofence-zoom-to"
    a7s-id="live-map-geofence-context-menu-zoom-to"
    (click)="onZoomToClicked()">
    <a i18n="@@S_ZOOM_TO">Zoom to</a>
  </fm-context-menu-item>
  <fm-context-menu-item [hasSeparator]="true"
    id="lnk-geofence-street-view"
    a7s-id="live-map-geofence-context-menu-street-view"
    [isDisabled]="!menuData.streetViewAvailable"
    (click)="onStreetViewClicked()">
    <a i18n="@@S_STREET_VIEW">Street view</a>
  </fm-context-menu-item>
  <fm-context-menu-item [hasSeparator]="true"
    id="lnk-geofence-edit-place"
    a7s-id="live-map-geofence-context-menu-edit-place"
    (click)="onEditPlaceClicked()">
    <a i18n="@@S_EDIT_GEOFENCE">Edit Place</a>
  </fm-context-menu-item>
  <fm-context-menu-item *ngIf="userPermissions.sendToGarmin"
    [hasSeparator]="true"
    id="lnk-geofence-send-location-to-garmin"
    a7s-id="live-map-geofence-context-menu-send-to-garmin"
    (click)="onLocationToGarminClicked()">
    <a i18n="@@S_SEND_LOCATION_TO_GARMIN">Send location to a Garmin</a>
  </fm-context-menu-item>
  <fm-context-menu-item *ngIf="userPermissions.directions"
    id="lnk-geofence-get-directions-to-here"
    a7s-id="live-map-geofence-context-menu-directions-to-here"
    (click)="onGetDirectionToClicked()">
    <a i18n="@@S_GET_DIRECTIONS_TO_HERE">Get Directions to here</a>
  </fm-context-menu-item>
  <fm-context-menu-item *ngIf="userPermissions.directions"
    id="lnk-geofence-get-directions-from-here"
    a7s-id="live-map-geofence-context-menu-directions-from-here"
    (click)="onGetDirectionFromClicked()">
    <a i18n="@@S_GET_DIRECTIONS_FROM_HERE">Get Directions from here</a>
  </fm-context-menu-item>
</fm-context-menu-panel>
